import React, { useMemo, useCallback } from 'react';
import {
  DISCIPLINES,
  DISCIPLINE_NAMES,
  CATEGORIES_BY_DISCIPLINE
} from '../../utils/constants';

const DisciplineSelector = ({ 
  selectedDiscipline, 
  selectedCategory, 
  onDisciplineChange, 
  onCategoryChange,
  disabled = false 
}) => {
  
  const disciplinesList = useMemo(() => 
    Object.entries(DISCIPLINES).map(([key, value]) => ({
      value,
      label: DISCIPLINE_NAMES[value]
    }))
  , []);

  const currentCategories = useMemo(() => 
    selectedDiscipline 
      ? Object.entries(CATEGORIES_BY_DISCIPLINE[selectedDiscipline] || {}).map(([key, value]) => ({
          value: key,
          label: value
        }))
      : []
  , [selectedDiscipline]);

  const handleDisciplineChange = useCallback((e) => {
    const newValue = e.target.value;
    onDisciplineChange(newValue);
    onCategoryChange('');
  }, [onDisciplineChange, onCategoryChange]);

  const handleCategoryChange = useCallback((e) => {
    const newValue = e.target.value;
    onCategoryChange(newValue);
  }, [onCategoryChange]);

  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ marginBottom: '15px' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
          Disciplina *
        </label>
        <select
          value={selectedDiscipline || ''}
          onChange={handleDisciplineChange}
          disabled={disabled}
          style={{
            width: '100%',
            padding: '10px',
            fontSize: '14px',
            borderRadius: '4px',
            border: '1px solid #999',
            backgroundColor: disabled ? '#eee' : '#fff',
            cursor: disabled ? 'not-allowed' : 'pointer',
            color: '#333'
          }}
        >
          <option value="">-- Selecciona una disciplina --</option>
          {disciplinesList && disciplinesList.length > 0 ? (
            disciplinesList.map(discipline => (
              <option key={discipline.value} value={discipline.value}>
                {discipline.label}
              </option>
            ))
          ) : (
            <option disabled>No hay disciplinas disponibles</option>
          )}
        </select>
      </div>

      {selectedDiscipline && currentCategories && currentCategories.length > 0 && (
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold' }}>
            Categoría *
          </label>
          <select
            value={selectedCategory || ''}
            onChange={handleCategoryChange}
            disabled={disabled}
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '14px',
              borderRadius: '4px',
              border: '1px solid #999',
              backgroundColor: disabled ? '#eee' : '#fff',
              cursor: disabled ? 'not-allowed' : 'pointer',
              color: '#333'
            }}
          >
            <option value="">-- Selecciona una categoría --</option>
            {currentCategories.map(category => (
              <option key={category.value} value={category.value}>
                {category.label}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};

export default DisciplineSelector;
